import { ECoworkingOfferType, IJsonQuery } from 'shared/json_query';

export const getCoworkingObjectType = (jsonQuery: IJsonQuery): string[] => {
  if (jsonQuery.coworking_offer_type?.value) {
    return jsonQuery.coworking_offer_type?.value?.map(String);
  }

  return [String(ECoworkingOfferType.Office)];
};
